export default "__VITE_ASSET__DcgNsll$__"